import { Flex } from '@pinchenterprisesnpm/friday-ui'
import { Form } from 'formik'
import { Link } from 'react-router-dom'
import { Container } from 'styled-bootstrap-grid'
import styled from 'styled-components'

export const UnStyledLink = styled(Link)`
  text-decoration: none;

  &:focus,
  &:hover,
  &:visited,
  &:link,
  &:active {
    text-decoration: none;
  }
`
export const LinkWrapper = styled(Link)`
  color: ${props => props.theme.palette.primary};
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`
export const PageTitle = styled.h1`
  color: ${({ theme: { palette } }) => palette.primary};
  font-size: ${({
    theme: {
      font: { sizes },
    },
  }) => sizes.large};
  padding-left: ${({ theme: { mp } }) => mp.sm};
  margin-bottom: ${({ theme: { mp } }) => mp.lg};
  display: flex;
  justify-content: space-between;

  & button {
    font-weight: normal;
  }

  & div {
    font-size: initial;
  }

  & > div {
    flex: 1;
  }
`

export const PageLayout = styled(Container)`
  padding-top: ${({ theme: { mp } }) => mp.sm};
  overflow-y: auto;
`

export const TitleWrapper = styled.div`
  display: flex;
  width: 100%;
  height: max-content;
  justify-content: space-between;
  align-items: center;
  margin: ${({ theme: { mp } }) => mp.md} 0;
`

export const CustomValidationError = styled.span`
  color: ${({ theme: { palette } }) => palette.danger};
  font-size: ${({
    theme: {
      font: { sizes },
    },
  }) => sizes.small};
`

export const DefaultColorAnchorLink = styled.a`
  color: inherit;
  text-decoration: none;
`
export const NoContent = styled(Flex)`
  height: inherit;
  background-color: ${({ theme: { palette } }) => palette.white};
  border-radius: 4px;
  text-align: center;
`
export const BoldSpan = styled.span`
  font-weight: ${({
    theme: {
      font: { weights },
    },
  }) => weights.bold};
`

// Styled formik Form component. This component should be used when using Formik in modals.
export const FormikForm = styled(Form)<{ fullWidth?: boolean }>`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
  ${({ fullWidth }) => fullWidth && 'width: 100%;'}
`

// This component should be used when we need to stopPropagation of events in modals.
export const StopPropagationDiv = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
`

export const ClickableText = styled.span`
  cursor: pointer;
  &:hover {
    color: ${({ theme: { palette } }) => palette.primary};
  }
`
